module.exports = __webpack_public_path__ + "media/kommissar_1.2b.9ec864aa.mp3";